import { render, staticRenderFns } from "./shortAnswer.vue?vue&type=template&id=100cba54&scoped=true&"
import script from "./shortAnswer.vue?vue&type=script&lang=js&"
export * from "./shortAnswer.vue?vue&type=script&lang=js&"
import style0 from "./shortAnswer.vue?vue&type=style&index=0&id=100cba54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100cba54",
  null
  
)

export default component.exports